// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/fonts/ABCWhyteInktrap-Book.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "WhyteInktrap";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype");
}
* {
  box-sizing: border-box;
  font-family: "Inter", sans-serif;
}

html, body {
  color: #222228;
}

.ValidationsModal_header__3lVSD {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #DDEAFB;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  height: 90px;
  padding: 0 38px;
  color: #122D62;
}
.ValidationsModal_header__3lVSD h4 {
  color: #222228;
  font-size: 18px;
  font-weight: 500;
}
.ValidationsModal_header__3lVSD .ValidationsModal_icon__QqGDh {
  height: 25px;
  cursor: pointer;
  border: 0.5px solid #222228;
  border-radius: 50%;
}

.ValidationsModal_content__Qn0Ih {
  padding: 20px 38px;
  color: #122D62;
}
.ValidationsModal_content__Qn0Ih .ValidationsModal_title__gO9UW {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 16px;
}
.ValidationsModal_content__Qn0Ih .ValidationsModal_wrapper__Ox-GT {
  margin-bottom: 24px;
}
.ValidationsModal_content__Qn0Ih .ValidationsModal_firstRow__FoD1U {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}
.ValidationsModal_content__Qn0Ih .ValidationsModal_firstRow__FoD1U:first-child {
  font-weight: 500;
}
.ValidationsModal_content__Qn0Ih .ValidationsModal_date__BimPE {
  font-weight: 500;
}
.ValidationsModal_content__Qn0Ih .ValidationsModal_subtitle__ItQyV {
  font-weight: 500;
  font-size: 16px;
  margin-bottom: 20px;
}
.ValidationsModal_content__Qn0Ih .ValidationsModal_text__1L4Yg {
  font-size: 14px;
}
.ValidationsModal_content__Qn0Ih .ValidationsModal_statusCell__Eivy- {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 22px;
  min-width: 88px;
  border-radius: 15px;
  padding: 0 8px;
  font-size: 10px;
  text-transform: uppercase;
  font-weight: 600;
}
.ValidationsModal_content__Qn0Ih .ValidationsModal_statusCell__Eivy-.ValidationsModal_openStatus__sgztu {
  background-color: #B4E1FA;
  color: #23A0E5;
}
.ValidationsModal_content__Qn0Ih .ValidationsModal_statusCell__Eivy-.ValidationsModal_inProgressStatus__Kb5JU {
  background-color: rgba(250, 182, 145, 0.76);
  color: #FF7427;
}
.ValidationsModal_content__Qn0Ih .ValidationsModal_statusCell__Eivy-.ValidationsModal_doneStatus__Z98E8 {
  background-color: #7ADDAF;
  color: #007940;
}
.ValidationsModal_content__Qn0Ih .ValidationsModal_noData__2LuhB {
  display: flex;
  justify-content: center;
  font-weight: 500;
  padding: 30px 0;
}`, "",{"version":3,"sources":["webpack://./src/core/styles.scss","webpack://./src/modals/ValidationsModal.module.scss"],"names":[],"mappings":"AAAA;EACE,2BAAA;EACA,+DAAA;ACCF;AD0BA;EACE,sBAAA;EACA,gCAzBS;ACCX;;AD2BA;EACE,cAVY;ACdd;;AATA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,yBDIU;ECHV,2BAAA;EACA,4BAAA;EACA,YAAA;EACA,eAAA;EACA,cDec;ACHhB;AAVE;EACE,cDWU;ECVV,eAAA;EACA,gBAAA;AAYJ;AATE;EACE,YAAA;EACA,eAAA;EACA,2BAAA;EACA,kBAAA;AAWJ;;AAPA;EACE,kBAAA;EACA,cDHc;ACahB;AARE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAUJ;AAPE;EACE,mBAAA;AASJ;AALE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAOJ;AALI;EACE,gBAAA;AAON;AAHE;EACE,gBAAA;AAKJ;AAFE;EACE,gBAAA;EACA,eAAA;EACA,mBAAA;AAIJ;AADE;EACE,eAAA;AAGJ;AAAE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;AAEJ;AAAI;EACE,yBDxEO;ECyEP,cDxEC;AC0EP;AACI;EACE,2CDzEQ;EC0ER,cDzEG;AC0ET;AAEI;EACE,yBD1EO;EC2EP,cD1EE;AC0ER;AAIE;EACE,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;AAFJ","sourcesContent":["@font-face {\n  font-family: 'WhyteInktrap';\n  src: url('./../assets/fonts/ABCWhyteInktrap-Book.otf') format('opentype');\n}\n\n//FONTS\n$mainFont: 'Inter', sans-serif;\n$secondaryFont: 'WhyteInktrap', sans-serif;\n\n// COLORS\n$lightBlue: #DDEAFB;\n$mediumBlue: #B4E1FA;\n$blue: #23A0E5;\n$darkBlue: #60748E;\n$lightGrey: #EAECF0;\n$lightOrange: rgba(250, 182, 145, 0.76);\n$orange: #FF7427;\n$red: #C60C30;\n$plusGreen: #EBFF99;\n$lightGreen: #7ADDAF;\n$green: #007940;\n$darkGreen: #112C22;\n$purple: #D7B7FF;\n$lightPurple: #DBD7FC;\n\n$primaryDark: #222228;\n$secondaryDark: #122D62;\n$white: #FFFFFF;\n\n* {\n  box-sizing: border-box;\n  font-family: $mainFont;\n}\n\nhtml, body {\n  color: $primaryDark;\n}","@import './../core/styles';\n\n.header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background-color: $lightBlue;\n  border-top-left-radius: 8px;\n  border-top-right-radius: 8px;\n  height: 90px;\n  padding: 0 38px;\n  color: $secondaryDark;\n\n  h4 {\n    color: $primaryDark;\n    font-size: 18px;\n    font-weight: 500;\n  }\n\n  .icon {\n    height: 25px;\n    cursor: pointer;\n    border: 0.5px solid $primaryDark;\n    border-radius: 50%;\n  }\n}\n\n.content {\n  padding: 20px 38px;\n  color: $secondaryDark;\n\n  .title {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 16px;\n    font-weight: 500;\n    margin-bottom: 16px;\n  }\n\n  .wrapper {\n    margin-bottom: 24px;\n  }\n\n\n  .firstRow {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 12px;\n\n    &:first-child {\n      font-weight: 500;\n    }\n  }\n\n  .date {\n    font-weight: 500;\n  }\n\n  .subtitle {\n    font-weight: 500;\n    font-size: 16px;\n    margin-bottom: 20px;\n  }\n\n  .text {\n    font-size: 14px;\n  }\n\n  .statusCell {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 22px;\n    min-width: 88px;\n    border-radius: 15px;\n    padding: 0 8px;\n    font-size: 10px;\n    text-transform: uppercase;\n    font-weight: 600;\n\n    &.openStatus {\n      background-color: $mediumBlue;\n      color: $blue;\n    }\n\n    &.inProgressStatus {\n      background-color: $lightOrange;\n      color: $orange;\n    }\n\n    &.doneStatus {\n      background-color: $lightGreen;\n      color: $green;\n    }\n  }\n\n  .noData {\n    display: flex;\n    justify-content: center;\n    font-weight: 500;\n    padding: 30px 0;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `ValidationsModal_header__3lVSD`,
	"icon": `ValidationsModal_icon__QqGDh`,
	"content": `ValidationsModal_content__Qn0Ih`,
	"title": `ValidationsModal_title__gO9UW`,
	"wrapper": `ValidationsModal_wrapper__Ox-GT`,
	"firstRow": `ValidationsModal_firstRow__FoD1U`,
	"date": `ValidationsModal_date__BimPE`,
	"subtitle": `ValidationsModal_subtitle__ItQyV`,
	"text": `ValidationsModal_text__1L4Yg`,
	"statusCell": `ValidationsModal_statusCell__Eivy-`,
	"openStatus": `ValidationsModal_openStatus__sgztu`,
	"inProgressStatus": `ValidationsModal_inProgressStatus__Kb5JU`,
	"doneStatus": `ValidationsModal_doneStatus__Z98E8`,
	"noData": `ValidationsModal_noData__2LuhB`
};
export default ___CSS_LOADER_EXPORT___;
